const enLabels = require('lang/en_US.json')

export const getLabelConfigById = (id) => {
  return {
    originalName: enLabels?.[id]?.name,
    helpText: enLabels?.[id]?.label
  }
}
